__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "Leap360-Container";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(855)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(387), __webpack_require__.e(855), __webpack_require__.e(462), __webpack_require__.e(625)]).then(() => (() => (__webpack_require__(4625))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(387), __webpack_require__.e(289), __webpack_require__.e(855)]).then(() => (() => (__webpack_require__(5289))))));
			register("react", "17.0.2", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			initExternal(8285);
			initExternal(7723);
			initExternal(6681);
			initExternal(4029);
			initExternal(7249);
			initExternal(9701);
			initExternal(6915);
			initExternal(9349);
			initExternal(5481);
			initExternal(683);
			initExternal(2957);
			initExternal(9065);
			initExternal(4183);
			initExternal(3553);
			initExternal(4125);
			initExternal(5909);
			initExternal(8173);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};